// extracted by mini-css-extract-plugin
module.exports = {"component":"ui-phone-input_component__coplA"};